import * as Sentry from "@sentry/react";

import type { GetFlightAvailabilityTokenCabinClass } from "@/types/codegen";

export const standarizedNames = {
  Economy: "Economy",
  PremiumEconomy: "Premium Economy",
  Business: "Business",
  FirstClass: "First Class",
};

// For reference:
//
// IRIX Standards:
// Y = Economy,
// W = Premium Economy,
// F = First class,
// C = Business class
//
// Travel Fusion with some differences from IRIX:
// Economy With Restrictions
// Economy Without Restrictions
// Economy Premium
// Business
// First
//
// Amadeus:
// First - class A, F, P, R
// Club (Business) - class C, D, I, J, Z
// W - Economy/Coach Premium
// M - Economy but not Economy/Coach Premium
// Y - Economy (Y = W + M)

function standarizeCabinClassName(cabinClass: string): string {
  switch (cabinClass.trim().toLowerCase()) {
    case "economy":
    case "economy class":
    case "economy standard":
    case "economy with restrictions":
    case "economy without restrictions":
      return standarizedNames.Economy;

    case "economy premium":
    case "economy premium class":
    case "premium economy":
    case "premium economy class":
    case "coach premium":
    case "coach premium class":
    case "economy/coach premium":
    case "economy/coach premium class":
      return standarizedNames.PremiumEconomy;

    case "business":
    case "business class":
    case "(club) business":
    case "(club) business class":
      return standarizedNames.Business;

    case "first":
    case "first class":
      return standarizedNames.FirstClass;

    default:
      return cabinClass;
  }
}

export function determineCabinClasses(
  cabinClasses: GetFlightAvailabilityTokenCabinClass[],
) {
  // unique cabin classes sorted alphabetically
  const results = Array.from(
    new Set(cabinClasses.map((c) => standarizeCabinClassName(c.type))),
  ).sort();

  for (const cabinClass of results) {
    if (!Object.values(standarizedNames).includes(cabinClass)) {
      Sentry.logger.warn(`Cannot standarize cabin class name`, { cabinClass });
    }
  }

  return results;
}
